'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minuteFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minuteFromNow.js
// module id = 707
// module chunks = 0